import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RecentMember } from "../../apis/api/DashboardApi";
import CustomTableWrapper from "../../Hooks/CustomTableWrapper";
import { useNavigate, useLocation } from "react-router-dom";
import Lodderr from "../../components/Lodder/Lodder";

const RecntMember = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const { Recentmember, loading } = useSelector((state) => state.DashboardSlice);

  useEffect(() => {
    dispatch(RecentMember());
  }, [dispatch]);

  const handleViewClick = (company_id, userId) => {
    if (company_id && userId) {
      navigate("/OtherProfile", {
        state: { company_id, userId, from: location.pathname },
      });
    }
  };

  return (
    <>
      {loading && <Lodderr />}
      <CustomTableWrapper
        title="Recent Members"
        data={Recentmember}
        itemsPerPage={10}
        enableSearch={true}
        searchKeys={["company_name", "company_email", "contact", "country"]}
        columns={[
          { label: "Company Logo", field: "company_logo" },
          { label: "Company Name", field: "company_name", sortable: true },
          { label: "Email", field: "company_email", sortable: true },
          { label: "Contact", field: "contact", sortable: true },
          { label: "Country", field: "country", sortable: true },

          { label: "Action", field: "action" },
        ]}
        renderRow={(item, index, currentPage, itemsPerPage) => (
          <tr key={index}>
            <td>
              <div className="rm-logo-wrap">
                <img
                  src={
                    item.company_logo?.replace("thumb/", "") ||
                    "/company-logo-design.jpg"
                  }
                  alt="Company Logo"
                  className="rm-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      process.env.PUBLIC_URL + "/company-logo-design.jpg";
                  }}
                />
              </div>
            </td>
            <td>
              <span className="rm-name">{item.company_name || "-"}</span>
            </td>
            <td>
              <span className="rm-email">{item.company_email || "-"}</span>
            </td>
            <td>{item.contact || "-"}</td>
            <td>
              <span className="rm-country">{item.country || "-"}</span>
            </td>
            <td>
              <button
                type="button"
                className="rm-view-btn"
                onClick={() => handleViewClick(item.id, item.member_id)}
                title="View Profile"
              >
                <i className="bx bx-show"></i> View
              </button>
            </td>
          </tr>
        )}
      />
    </>
  );
};

export default RecntMember;
